<template>
    <div>
        <div class="w-100 bgray-200 mb-5 fw-400">
            <h2 class="py-5 fw-400 text-center"> CAMPAIGN LIST </h2>
        </div>
        <!-- <b-button v-if="is_admin >=3" class="f-105 fw-500" variant="dark-border" @click="newCampaign"><fa icon="plus" class="mr-2"></fa>새 캠페인</b-button>  -->

        <b-container v-if="is_admin >= 3 && !load_error">
            <div class="text-right mb-4">
                <b-button class="f-105 fw-500" variant="dark-border" @click="newCampaign">
                    <fa icon="plus" class="mr-2"></fa>새 캠페인
                </b-button>
            </div>
        </b-container>
        <b-container v-if="is_campaigns_loaded == true && campaigns_all_period.length > 0">
            <b-tabs content-class="mt-3" :value="active_period_idx" @input="selectPeriodTab">
                <b-tab v-for="periods_campaigns in campaigns_all_period"
                    :key="`campaign-period-${periods_campaigns.period}`"
                    :title="periods_campaigns.period"
                    >
                    <b-table-simple hover class="sep-table">
                        <b-thead>
                            <b-tr class="">
                                <b-td>상태</b-td>
                                <b-td>산업</b-td>
                                <b-td> 캠페인명</b-td>
                                <b-td>참여기업수</b-td>
                                <b-td>관리</b-td>
                                <b-td>편집</b-td>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, _campaign_idx) in periods_campaigns.campaigns"
                                :key="`period-campaigns-${_campaign_idx}`"
                                >
                                <b-td class="py-2">
                                    <b-dropdown
                                        :text="item.campaign_state" 
                                        :variant="item.campaign_state == '답변중' ? 'icon-blue' : 'icon-dark'"
                                        :disabled="is_admin < 4"
                                        >
                                        <b-dropdown-item-button 
                                            :active="item.campaign_state == '생성/편집'"
                                            :disabled="item.campaign_state == '생성/편집'"
                                            @click="confirmChangeStatus(item, '생성/편집')"
                                            >
                                            생성/편집
                                        </b-dropdown-item-button>
                                        <b-dropdown-item-button 
                                            :active="item.campaign_state == '답변중'"
                                            :disabled="item.campaign_state == '답변중'"
                                            @click="confirmChangeStatus(item, '답변중')"
                                            >
                                            답변중
                                        </b-dropdown-item-button>
                                        <b-dropdown-item-button 
                                            :active="item.campaign_state == '종료'"
                                            :disabled="item.campaign_state == '종료'"
                                            @click="confirmChangeStatus(item, '종료')"
                                            >
                                            종료
                                        </b-dropdown-item-button>
                                    </b-dropdown>
                                </b-td>
                                <b-td class="py-2"> {{ getIndustry(item.industry_id) }} </b-td>

                                <b-td class="py-2">
                                    <b-badge variant="advance" class="mr-2">{{ item.campaign_id }}</b-badge>
                                    {{ item.campaign_name }}
                                </b-td>
                                <b-td class="py-2"> {{ item.scoring_target_companies.length }} </b-td>
                                <b-td class="py-2">
                                    <b-button-group>
                                        <b-button variant="dark-border"
                                            size="sm"
                                            @click="enterCampaign(item, 'CampaignProgress')"
                                            >
                                            진행현황
                                        </b-button>
                                        <b-button
                                            variant="dark-border"
                                            size="sm"
                                            :disabled="checkAllowed(item.campaign_state, item.type, is_admin, 2) !== true"
                                            @click="enterCampaign(item, 'Answers')"
                                            >
                                            기업별 답변
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            :disabled="checkAllowed(item.campaign_state, item.type, is_admin, 3) !== true"
                                            variant="dark-border" @click="enterCampaign(item, 'CampaignReport')"
                                            >
                                            평가결과
                                        </b-button>
                                    </b-button-group>
                                </b-td>
                                <b-td class="py-2">
                                    <div v-if="is_admin >= 4 || item.type == 'owner'">
                                        <div v-if="item.campaign_state == '생성/편집'">
                                            <b-button class="py-1 px-2 ml-1"
                                                variant="dark-border"
                                                size="sm"
                                                :disabled="item.campaign_state != '생성/편집'"
                                                @click="editCampaign(item)"
                                                >
                                                <fa icon="pen"></fa>
                                            </b-button></div>
                                        <div v-else :id="`camp-edit-btn_${item.campaign_id}`">
                                            <b-button size="sm"
                                                class="py-1 px-2 ml-1"
                                                variant="dark-border"
                                                :disabled="item.campaign_state !== '생성/편집'"
                                                @click="editCampaign(item)"
                                                >
                                                <fa icon="pen"></fa>
                                            </b-button>
                                            <b-tooltip :target="`camp-edit-btn_${item.campaign_id}`" triggers="hover">
                                                캠페인 상태를 '생성/편집'으로 변경 후 편집할 수 있습니다.
                                            </b-tooltip>
                                        </div>
                                    </div>
                                    <div v-else> {{ item.type == 'owner' ? '' : `권한 없음` }} </div>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-tab>
            </b-tabs>

            <hr class="border-0 pb-5">

            <b-card id="campaign-mgt-tip" class="mb-5 bgray-100 border-0">
                <b-card-sub-title class="mb-0 text-black-50">
                    <fa icon="info-circle" class="mr-1"></fa>캠페인 상태 설정
                </b-card-sub-title>
                <b-card-text class="text-black-50 pb-1">
                    생성/편집/완료 상태는 캠페인 기간과 상관없이 상태바꾸기로 설정 가능합니다.<br>
                    캠페인 편집은 생성/편집 상태에서만 가능하며, 생성/편집중인 캠페인은 캠페인 페이지에 나타나지 않습니다.
                    신규 캠페인 구축 시 생성/편집 상태로 저장됩니다.
                </b-card-text>
            </b-card>
            <hr class="bottom-space border-0">
        </b-container>
        <PageEmptyComponent v-else-if="load_error" :error="load_error" @retry="loadCampaigns" />
        <b-container v-else-if="is_campaigns_loaded == true" class="py-5">
            <div class="text-center gray-600 bgray-200 py-4">등록된 캠페인이 없습니다. 새 캠페인을 만들어 주세요.</div>
        </b-container>
        <b-container v-else class="py-5">
            <b-skeleton-table :rows="2" :columns="4" :table-props="{ bordered: false, striped: false }"></b-skeleton-table>
        </b-container>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import PageEmptyComponent from '@shared/components/admin/components/common/PageEmptyComponent.vue';

export default {
    name: 'CampaignList',
    components: { PageEmptyComponent },
    props: {
        urlError: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            load_error: '',
            // store 의 캠페인 목록은 다른 화면(진행현황 등)이 1건으로 바꿔 두기도 한다 — 이 화면이 직접 다 불러온 뒤에만 ?period 를 정리
            is_list_fetched: false,
        };
    },
    computed: {
        ...mapState('industry_campaigns', ['industries']),
        ...mapState('auditors', {
            admin_user_space: state => state.admin_user_space,
            is_admin_space_loaded: state => state.admin_space_loaded
        }),
        ...mapState('industry_campaigns', ['campaigns', 'is_campaigns_loaded']),
        ...mapState('score', ['temp_target_companies']),
        user_id() {
            return this.$store.state.user_id;
        },
        is_admin() {
            return this.$store.getters.isAdmin;
        },
        campaigns_all_period() {
            let new_campaign = [];
            let periods = [...new Set(this.campaigns.map(x => x.period))];

            periods.forEach(p => {
                let temp_obj = {};
                temp_obj['period'] = p;
                temp_obj['campaigns'] = this.campaigns.filter(y => y.period == p);
                new_campaign.push(temp_obj);
            });
            return new_campaign;
        },
        // 기본 탭은 가장 최근 기간 — URL 에서는 생략한다
        default_period() {
            return this.campaigns_all_period.map(x => x.period).filter(Boolean).sort().reverse()[0];
        },
        active_period_idx() {
            const idx = this.campaigns_all_period.findIndex(x => x.period === this.$route.query.period);
            return idx > -1 ? idx : this.campaigns_all_period.findIndex(x => x.period === this.default_period);
        },
        // 목록이 뜬 뒤 ?period 가 없는 기간이거나 기본(최신) 기간이면 URL 에서 뺀다
        is_period_query_stale() {
            const period = this.$route.query.period;
            if (period == null || !this.is_list_fetched || !this.is_campaigns_loaded || !this.campaigns_all_period.length) return false;
            return period === this.default_period || !this.campaigns_all_period.some(x => x.period === period);
        },
    },
    watch: {
        is_period_query_stale: {
            immediate: true,
            handler(stale) {
                if (!stale) return;
                const query = {...this.$route.query};
                delete query.period;
                this.$router.replace({query}).catch(() => {});
            }
        },
        // is_reloaded: {
        //     immediate: true,
        //     async handler (is_reloaded) {
        //         if (is_reloaded === true) {
        //             return is_reloaded = false
        //         } else {
        //             return is_reloaded = false
        //         }
        //     }
        // }
    },
    async created() {
        if(this.$route.params?.urlError){
            this.$showModal({
                type: 'alert',
                state: 'warning',
                title: this.$t('잘못된 접근'), // content는 기본값 사용, title만 변경
                message: this.$t('URL에 필요한 정보가 부족합니다. 개발팀에 문의해주세요.'),
            });
        }
        
        try {
            this.set_admin_mode('camp');
            await this.loadCampaigns();
        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    alert('다중 로그인이 감지되었습니다. 다시 로그인해 주십시오.');
                    this.$store.dispatch('logout').then(() => { this.$router.push({ name: 'Login' }); });
                }
            }
        }

        if (this.is_admin_space_loaded !== true) {
            await this.initiateSpace(this.user_id);
        }
    },
    methods: {
        ...mapActions('auditors', ['initiateSpace']),
        ...mapActions('industry_campaigns', ['readCampaignsIndustries', 'changeStatus', 'readAllIndustries']),
        ...mapActions('reviews', ['initiateReviews']),
        ...mapMutations('industry_campaigns', ['update_is_campaigns_loaded']),
        ...mapMutations('score', ['add_all_temp_target_companies']),
        ...mapMutations(['set_admin_mode']),
        selectPeriodTab(idx) {
            const period = this.campaigns_all_period[idx]?.period;
            if (!period || idx === this.active_period_idx) return;
            const query = {...this.$route.query, period};
            if (period === this.default_period) delete query.period;
            this.$router.push({query}).catch(() => {});
        },
        getIndustry(industry_id) {
            let idx = this.industries.findIndex(x => x.industry_id == industry_id);
            if (idx > -1) {
                return this.industries[idx].industry_name;
            }
        },
        async loadCampaigns() {
            this.load_error = '';
            this.update_is_campaigns_loaded(false);
            await this.readAllIndustries(this.user_id);
            // store 액션이 오류를 삼키고 Error 를 반환한다
            const res = await this.readCampaignsIndustries(this.user_id);
            if (res instanceof Error) {
                this.load_error = '캠페인 목록을 불러오지 못했습니다.';
            } else {
                this.is_list_fetched = true;
            }
        },
        async confirmChangeStatus(campaign, status) {
            const ok = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '캠페인 상태 변경',
                message: `'${campaign.campaign_name}' (참여기업 ${campaign.scoring_target_companies.length}개)의 상태를 '${campaign.campaign_state}'에서 '${status}'(으)로 변경합니다. `
                    + (status === '생성/편집' ? '생성/편집 상태인 캠페인은 캠페인 페이지에 나타나지 않습니다.' : '참여기업의 캠페인 진행에 바로 반영됩니다.'),
            });
            if (!ok) return;

            try {
                await this.changeStatus({ campaign, status });
                this.$EventBus.$emit('toast-success', '상태 변경', `'${campaign.campaign_name}' 상태를 '${status}'(으)로 변경했습니다.`);
            } catch (error) {
                if (error?.response?.status === 401) return;
                this.$EventBus.$emit('toast-failure', '상태 변경 실패', '캠페인 상태를 변경하지 못했습니다. 잠시 후 다시 시도해 주세요.');
            }
        },
        newCampaign() {
            this.$router.push({ name: 'EditingCampaignAttr', query: { value_new: true } });
        },
        editCampaign(campaign) {
            this.$store.commit('update_campaign', campaign);
            this.$router.push({ name: 'EditingCampaignAttr', query: { value_new: false, campaign_id: campaign.campaign_id} });
        },
        async enterCampaign(campaign, mode) {
            this.$router.push({ name: mode, query: { cmp: campaign.campaign_id, template_code: campaign.template_code, campaign_name: campaign.campaign_name,  admin_mode: 'camp' } });
        },
        checkAllowed(campaign_state, campaign_type, user_admin_level, target_admin_level) {
            if (campaign_state == '종료') { return true; }
            else if (user_admin_level == 4) { return true; }
            else if (campaign_type == 'owner') { return true; }
            else if (campaign_type == 'auditor' && user_admin_level < target_admin_level) {
                return false;
            }
            else return true;
        },
        checkOptions(process_options_array) {
            if (process_options_array != null) {
                // console.log(process_options_array);
                let idx = process_options_array.findIndex(x => { return x == '현장실사'; });
                if (idx > -1) { return true; }
            }
            else return false;
        }
    }
};
</script>

<style scoped>
#campaign-pause,
#campaign-stop,
#campaign-play {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    padding: 0.25rem 0.5rem;
}

.to-right {
    border: 0;
    width: 100%;
    height: 14px;
    position: absolute;
    right: 0;
    bottom: 0;
}

.to-right::before {
    content: "";
    position: absolute;
    right: 0;
    margin-right: -6px;
    border-top: 1px solid var(--gray-700);
    width: 20.5px;
    transform: rotate(45deg);
    transform-Origin: 0% 0%;
}

.to-right-dashed {
    border: 0;
    width: 100%;
    height: 14px;
    position: absolute;
    right: 0;
    bottom: 0;
}

.to-right-dashed::before {
    content: "";
    position: absolute;
    right: 0;
    margin-right: -6px;
    border-top: 1px dashed var(--gray-700);
    width: 20.5px;
    transform: rotate(45deg);
    transform-Origin: 0% 0%;
}

.floating1 {
    animation-name: floating1;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    margin-left: 30px;
    margin-top: 5px;
}

@keyframes floating1 {
    from {
        transform: translate(0, 0px);
    }

    65% {
        transform: translate(0, 4px);
    }

    to {
        transform: translate(0, -0px);
    }
}

.floating2 {
    animation-name: floating2;
    animation-delay: 0.5s;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    margin-left: 30px;
    margin-top: 5px;
}

@keyframes floating2 {
    from {
        transform: translate(0, 0px);
    }

    65% {
        transform: translate(0, 4px);
    }

    to {
        transform: translate(0, -0px);
    }
}

.hover-blue:hover {
    color: var(--blue);
}

.hover-dark:hover {
    color: var(--gray-700);
}</style>
